/* Shared two-tier header (service bar + site menus) and responsive navigation for print, gallery and shop. */
(function () {
  'use strict';
  var header = document.querySelector('.site-header');
  if (!header) return;
  var nav = header.querySelector('.site-nav');
  var toggle = header.querySelector('.nav-toggle');
  if (!nav || !toggle) return;
  nav.id = nav.id || 'site-nav';
  function label() { nav.setAttribute('aria-label', document.documentElement.lang === 'en' ? 'Site navigation' : 'サイト内メニュー'); }
  label();
  toggle.setAttribute('aria-controls', nav.id);
  // Every dropdown in the site row, including Shopify's store-specific .shop-menu-group.
  var menus = Array.from(nav.querySelectorAll('details.nav-menu')).filter(function (menu) { return menu.querySelector('summary'); });
  var hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var hoverCloseTimer;
  function hoverEnabled() { return hoverPointer.matches && !header.classList.contains('header-compact'); }
  function closeMenus(except) {
    menus.forEach(function (menu) { if (menu !== except) menu.open = false; });
  }
  function setNav(open) {
    header.classList.toggle('nav-open', open);
    document.body.classList.toggle('nav-locked', open);
    toggle.setAttribute('aria-expanded', String(open));
    if (!open) closeMenus();
  }
  // Keep an open panel inside the viewport: flip it to the trigger's right edge when it would overflow,
  // and when the flipped panel would leave the left edge instead (wide EN columns near 1200px), pin it 12px from the left.
  function alignPanel(menu) {
    var panel = menu.querySelector('.nav-panel');
    if (!panel) return;
    panel.classList.remove('nav-panel--flip');
    panel.style.left = '';
    if (!menu.open || header.classList.contains('header-compact')) return;
    var rect = panel.getBoundingClientRect();
    if (rect.right <= window.innerWidth - 12) return;
    panel.classList.add('nav-panel--flip');
    rect = panel.getBoundingClientRect();
    if (rect.left >= 12) return;
    panel.classList.remove('nav-panel--flip');
    rect = panel.getBoundingClientRect();
    panel.style.left = Math.round(12 - rect.left) + 'px';
  }
  toggle.addEventListener('click', function () { setNav(!header.classList.contains('nav-open')); });
  menus.forEach(function (menu) {
    var trigger = menu.querySelector('summary');
    menu.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'touch' || !hoverEnabled()) return;
      clearTimeout(hoverCloseTimer);
      closeMenus(menu); menu.open = true;
    });
    menu.addEventListener('pointerleave', function (event) {
      if (event.pointerType === 'touch' || !hoverEnabled()) return;
      clearTimeout(hoverCloseTimer);
      // Allow the pointer to cross the space between the label and its panel.
      hoverCloseTimer = setTimeout(function () {
        if (hoverEnabled() && !menu.matches(':hover') && !menu.contains(document.activeElement)) menu.open = false;
      }, 220);
    });
    trigger.addEventListener('click', function () { if (!menu.open) closeMenus(menu); });
    menu.addEventListener('toggle', function () {
      trigger.setAttribute('aria-expanded', String(menu.open));
      alignPanel(menu);
    });
    trigger.setAttribute('aria-expanded', String(menu.open));
    trigger.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault(); closeMenus(menu); menu.open = true;
      var first = menu.querySelector('.nav-panel a'); if (first) first.focus();
    });
  });
  nav.addEventListener('click', function (event) {
    if (event.target.closest('a')) setNav(false);
  });
  document.addEventListener('click', function (event) { if (!header.contains(event.target)) setNav(false); });
  header.addEventListener('focusout', function () {
    requestAnimationFrame(function () {
      menus.forEach(function (menu) { if (!menu.contains(document.activeElement) && !(hoverEnabled() && menu.matches(':hover'))) menu.open = false; });
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var openMenu = menus.find(function (menu) { return menu.open; });
      if (openMenu) { event.preventDefault(); openMenu.open = false; openMenu.querySelector('summary').focus(); }
      else if (header.classList.contains('nav-open')) { setNav(false); toggle.focus(); }
    }
    if (event.key === 'Tab' && header.classList.contains('nav-open')) {
      var stops = Array.from(header.querySelectorAll('a,button,summary,input:not([type="hidden"])')).filter(function (el) {
        return !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
      });
      var first = stops[0], last = stops[stops.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  // Exact page links (panel items and how-to links), separate from the service bar's current-service indicator.
  nav.querySelectorAll('.nav-panel a, .nav-group--guide > a').forEach(function (link) {
    var url = new URL(link.href);
    if (url.origin === location.origin && url.pathname === location.pathname && !url.hash && !url.search) {
      link.setAttribute('aria-current', 'page');
      var owner = link.closest('details.nav-menu');
      if (owner) owner.classList.add('nav-current');
    }
  });
  var scheduled = false;
  function navigationFits() {
    // Measure the flex row itself. scrollWidth also includes absolutely positioned
    // cart badges and open dropdowns, which do not take space in the header row.
    var style = getComputedStyle(nav);
    var items = Array.from(nav.children).filter(function (item) {
      return getComputedStyle(item).display !== 'none';
    });
    var required = items.reduce(function (width, item) {
      var itemStyle = getComputedStyle(item);
      return width + item.getBoundingClientRect().width +
        (parseFloat(itemStyle.marginLeft) || 0) + (parseFloat(itemStyle.marginRight) || 0);
    }, Math.max(0, items.length - 1) * (parseFloat(style.columnGap) || 0));
    var available = nav.getBoundingClientRect().width -
      (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0) -
      (parseFloat(style.borderLeftWidth) || 0) - (parseFloat(style.borderRightWidth) || 0);
    return required <= available + 1;
  }
  function layout() {
    scheduled = false;
    header.classList.remove('header-compact');
    var compact = window.matchMedia('(max-width:1120px)').matches || !navigationFits();
    header.classList.toggle('header-compact', compact);
    // Reposition open panels after resizing, language changes and font loading.
    menus.forEach(alignPanel);
    if (!compact) {
      if (header.classList.contains('nav-open')) setNav(false);
    }
    var height = Math.ceil(header.getBoundingClientRect().height) + 'px';
    if (document.documentElement.style.getPropertyValue('--header-height') !== height) {
      document.documentElement.style.setProperty('--header-height', height);
    }
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(layout); }
  }
  window.addEventListener('resize', schedule);
  document.addEventListener('toyobi:languagechange', function () { label(); schedule(); });
  new MutationObserver(schedule).observe(nav, {childList:true, subtree:true, characterData:true});
  if (window.ResizeObserver) new ResizeObserver(schedule).observe(header);
  if (document.fonts) document.fonts.ready.then(schedule);
  layout();
  // Old "?service-menu=" bookmarks: drop the parameter quietly; nothing opens and nothing throws.
  var url = new URL(location.href);
  if (url.searchParams.has('service-menu')) {
    url.searchParams.delete('service-menu');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  }
})();
